var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c(
        "b-form",
        { attrs: { "data-vv-scope": "bidder-form" } },
        [
          _c(
            "b-form-group",
            {
              staticClass: "mb-3",
              attrs: { label: "Rut", "label-for": "iut" }
            },
            [
              _c("b-form-input-rut", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|validateRut",
                    expression: "'required|validateRut'"
                  }
                ],
                attrs: {
                  id: "iut",
                  name: "iut",
                  "data-cy": "bidder-iut",
                  placeholder: "Rut",
                  state: _vm.errors.has("bidder-form.iut") ? false : null,
                  "data-vv-as": "Rut",
                  disabled: !!_vm.bidder.id
                },
                model: {
                  value: _vm.bidder.identification,
                  callback: function($$v) {
                    _vm.$set(_vm.bidder, "identification", $$v)
                  },
                  expression: "bidder.identification"
                }
              }),
              _c("b-form-invalid-feedback", [
                _vm._v(" " + _vm._s(_vm.errors.first("bidder-form.iut")) + " ")
              ])
            ],
            1
          ),
          _c(
            "b-form-group",
            {
              staticClass: "mb-3",
              attrs: {
                "data-vv-as": "Nombre / razón social",
                label: "Nombre / razón social",
                "label-for": "name"
              }
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|max:100",
                    expression: "'required|max:100'"
                  }
                ],
                attrs: {
                  id: "name",
                  name: "name",
                  "data-cy": "bidder-name",
                  placeholder: "Nombre",
                  "data-vv-as": "Nombre",
                  state: _vm.errors.has("bidder-form.name") ? false : null
                },
                model: {
                  value: _vm.bidder.name,
                  callback: function($$v) {
                    _vm.$set(_vm.bidder, "name", $$v)
                  },
                  expression: "bidder.name"
                }
              }),
              _c("b-form-invalid-feedback", [
                _vm._v(" " + _vm._s(_vm.errors.first("bidder-form.name")) + " ")
              ])
            ],
            1
          ),
          _c(
            "b-form-group",
            {
              staticClass: "mb-3",
              attrs: { label: "Giro", "label-for": "fantasyCompanyName" }
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|max:40",
                    expression: "'required|max:40'"
                  }
                ],
                attrs: {
                  id: "giro",
                  name: "giro",
                  "data-cy": "bidder-giro",
                  "data-vv-as": "Giro",
                  placeholder: "Giro",
                  state: _vm.errors.has("bidder-form.giro") ? false : null
                },
                model: {
                  value: _vm.bidder.giro,
                  callback: function($$v) {
                    _vm.$set(_vm.bidder, "giro", $$v)
                  },
                  expression: "bidder.giro"
                }
              }),
              _c("b-form-invalid-feedback", [
                _vm._v(" " + _vm._s(_vm.errors.first("bidder-form.giro")) + " ")
              ])
            ],
            1
          ),
          _c(
            "b-form-group",
            {
              staticClass: "mb-3",
              attrs: { label: "Dirección", "label-for": "address" }
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|max:80",
                    expression: "'required|max:80'"
                  }
                ],
                attrs: {
                  id: "address",
                  name: "address",
                  "data-cy": "bidder-address",
                  "data-vv-as": "Dirección",
                  placeholder: "Dirección",
                  state: _vm.errors.has("bidder-form.address") ? false : null
                },
                model: {
                  value: _vm.bidder.address,
                  callback: function($$v) {
                    _vm.$set(_vm.bidder, "address", $$v)
                  },
                  expression: "bidder.address"
                }
              }),
              _c("b-form-invalid-feedback", [
                _vm._v(
                  " " + _vm._s(_vm.errors.first("bidder-form.address")) + " "
                )
              ])
            ],
            1
          ),
          _c(
            "b-form-group",
            {
              staticClass: "mb-3",
              attrs: { label: "Comuna", "label-for": "commune" }
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|max:20",
                    expression: "'required|max:20'"
                  }
                ],
                attrs: {
                  "data-vv-as": "Comuna",
                  id: "commune",
                  name: "commune",
                  "data-cy": "bidder-commune",
                  placeholder: "Comuna",
                  state: _vm.errors.has("bidder-form.commune") ? false : null
                },
                model: {
                  value: _vm.bidder.commune,
                  callback: function($$v) {
                    _vm.$set(_vm.bidder, "commune", $$v)
                  },
                  expression: "bidder.commune"
                }
              }),
              _c("b-form-invalid-feedback", [
                _vm._v(
                  " " + _vm._s(_vm.errors.first("bidder-form.commune")) + " "
                )
              ])
            ],
            1
          ),
          _c(
            "b-form-group",
            {
              staticClass: "mb-3",
              attrs: { label: "Ciudad", "label-for": "city" }
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|max:20",
                    expression: "'required|max:20'"
                  }
                ],
                attrs: {
                  "data-vv-as": "Ciudad",
                  id: "city",
                  name: "city",
                  "data-cy": "bidder-city",
                  placeholder: "Ciudad",
                  state: _vm.errors.has("bidder-form.city") ? false : null
                },
                model: {
                  value: _vm.bidder.city,
                  callback: function($$v) {
                    _vm.$set(_vm.bidder, "city", $$v)
                  },
                  expression: "bidder.city"
                }
              }),
              _c("b-form-invalid-feedback", [
                _vm._v(" " + _vm._s(_vm.errors.first("bidder-form.city")) + " ")
              ])
            ],
            1
          ),
          _c(
            "b-form-group",
            {
              staticClass: "mb-3",
              attrs: { label: "Correo", "label-for": "email" }
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|email|max:80",
                    expression: "'required|email|max:80'"
                  }
                ],
                attrs: {
                  "data-vv-as": "Correo",
                  id: "email",
                  name: "email",
                  "data-cy": "bidder-email",
                  placeholder: "Correo",
                  state: _vm.errors.has("bidder-form.email") ? false : null
                },
                model: {
                  value: _vm.bidder.email,
                  callback: function($$v) {
                    _vm.$set(_vm.bidder, "email", $$v)
                  },
                  expression: "bidder.email"
                }
              }),
              _c("b-form-invalid-feedback", [
                _vm._v(
                  " " + _vm._s(_vm.errors.first("bidder-form.email")) + " "
                )
              ])
            ],
            1
          ),
          _c(
            "b-form-group",
            {
              staticClass: "mb-3",
              attrs: { label: "Contacto", "label-for": "contact" }
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: true, regex: _vm.phoneRegex },
                    expression: "{ required: true, regex: phoneRegex }"
                  }
                ],
                attrs: {
                  "data-vv-as": "Contacto",
                  id: "contact",
                  name: "contact",
                  placeholder: "Escriba en formato +56912345678",
                  "data-cy": "bidder-contact",
                  state: _vm.errors.has("bidder-form.contact") ? false : null
                },
                model: {
                  value: _vm.bidder.phone,
                  callback: function($$v) {
                    _vm.$set(_vm.bidder, "phone", $$v)
                  },
                  expression: "bidder.phone"
                }
              }),
              _c("b-form-invalid-feedback", [
                _vm._v(
                  " " + _vm._s(_vm.errors.first("bidder-form.contact")) + " "
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mr-1 text-right",
                  attrs: { variant: "primary", "data-cy": "next-button" },
                  on: {
                    click: function($event) {
                      return _vm.createBidder()
                    }
                  }
                },
                [_vm._v(" Guardar ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }